import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { VehicleUsage } from 'src/app/shared/models/vehicle-usages/vehicle-usages';
import { VehicleUsageRequest } from 'src/app/shared/models/vehicle-usages/vehicle-usage-request';
import { VehicleUsagesService } from 'src/app/shared/api-services/vehicle-usages.service';
import { TenantService } from 'src/app/shared/api-services/tenant.service';

@Component({
  selector: 'app-vehicle-usage-edit-modal',
  imports: [CommonModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './vehicle-usage-edit-modal.component.html',
  styleUrl: './vehicle-usage-edit-modal.component.scss',
  standalone: true,
})
export class VehicleUsageEditModalComponent implements OnInit {
  @Input() data: VehicleUsage;
  @Output() onUpdate = new EventEmitter<VehicleUsageRequest>();

  form: FormGroup;
  incompatibleMileage: boolean = false;
  tenantId: string;

  constructor(
    public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private vehicleUsagesService: VehicleUsagesService,
    private tenantService: TenantService
  ) {
    this.tenantId = this.tenantService.getTenantId();
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.form = this.fb.group({
      startMileage: [
        this.data?.startMileage || 0,
        [Validators.required, Validators.min(0)],
      ],
      endMileage: [this.data?.endMileage || null, [Validators.min(0)]],
    });

    // Monitora i cambiamenti nei campi del chilometraggio
    this.form.valueChanges.subscribe(() => {
      this.checkMileageCompatibility();
    });
  }

  checkMileageCompatibility(): void {
    const startMileage = this.form.get('startMileage').value;
    const endMileage = this.form.get('endMileage').value;

    if (startMileage && endMileage && endMileage < startMileage) {
      this.incompatibleMileage = true;
    } else {
      this.incompatibleMileage = false;
    }
  }

  saveMileage(): void {
    if (this.form.valid && !this.incompatibleMileage) {
      const updatedData: VehicleUsageRequest = {
        ...this.data,
        startMileage: this.form.get('startMileage').value,
        endMileage: this.form.get('endMileage').value,
      };

      this.vehicleUsagesService
        .updateVehicleUsage$(this.tenantId, this.data.id, updatedData)
        .subscribe({
          next: () => {
            this.onUpdate.emit(updatedData);
            this.bsModalRef.hide();
          },
        });
    }
  }
}
